import Select from "react-select";
import React, { useRef, useState } from "react";
import IGerencia from "../../entities/IGerencia";
import IRequisitosNormativos from "../../entities/IRequisitosNormativos";
import { ITipoDesviacion } from "../../entities/ITipoDesviacion";
import IUnidad from "../../entities/IUnidad";
import IVicePresidencia from "../../entities/IVicePresidencia";
import { getAPI } from "../../helpers/httpHelper";
import { usePromiseEffect } from "../../helpers/promiseEffect";
import { cognitoUserToken } from "../../helpers/userHelper";
import {
  API_ADMIN_ESTADO_DESVIACION,
  API_ADMIN_GERENCIA,
  API_ADMIN_REQ_NORMATIVOS,
  API_ADMIN_TIPO_DESVIACION,
  API_ADMIN_UNIDAD,
  API_VPP,
  ROW_COUNT,
  URL_SUPPORT,
} from "../../helpers/variableHelper";
import DesviacionService from "../../services/DesviacionService";
import { IDesviacion, ISearchByReporteDesviacion } from "../../entities/IDesviacion";
import { ITipo_Campo } from "../../helpers/IFormHelper";
import { CellContext, createColumnHelper } from "@tanstack/react-table";
import { shortDate } from "../../helpers/dateHelper";
import { IComboboxOption } from "../../entities/helper/IComboboxOption";
import { IEstadoDesviacion } from "../../entities/IEstadoDesviacion";
import moment from "moment";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import { AdminListaPagination, IPagination } from "../../controls/AdminListaPagination";
import { cParamsActiveOrderTitle, cParamsActive } from "../../helpers/paramsHelper";
import Loading from "../../cross/Loading";
import RenderTitle from "../../controls/RenderTitle";
import RenderValue from "../../controls/RenderValue";
const MySwal = withReactContent(Swal);

interface IReporteDesviacionProps {
  items?: Array<IDesviacion>;
  busqueda?: boolean;
  cbTipoDesviacion?: Array<ITipoDesviacion>;
  cbVicepresidencia?: Array<IVicePresidencia>;
  cbRequisitoNormativo?: Array<IRequisitosNormativos>;
  cbGerenciaSubgerencia?: Array<IGerencia>;
  cbEstado?: Array<IEstadoDesviacion>;
  cbUnidadProyecto?: Array<IUnidad>;
  is_test?: boolean;
}

export default function ReporteDesviacion({
  is_test,
  items,
  busqueda,
  cbTipoDesviacion,
  cbVicepresidencia,
  cbRequisitoNormativo,
  cbGerenciaSubgerencia,
  cbEstado,
  cbUnidadProyecto,
}: IReporteDesviacionProps) {
  const [token, setToken] = useState("");

  const [pageSize, setPageSize] = useState(ROW_COUNT);
  const [comboVcc, setComboVcc] = useState<Array<IVicePresidencia>>(cbVicepresidencia || []);
  const [comboGSG, setComboGSG] = useState<Array<IGerencia>>(cbGerenciaSubgerencia || []);
  const [comboRN, setComboRN] = useState<Array<IRequisitosNormativos>>(cbRequisitoNormativo || []);
  const [comboTD, setComboTD] = useState<Array<ITipoDesviacion>>(cbTipoDesviacion || []);
  const [comboUP, setComboUP] = useState<Array<IUnidad>>(cbUnidadProyecto || []);
  const [comboED, setComboED] = useState<Array<IEstadoDesviacion>>(cbEstado || []);

  const [vpp, setVpp] = useState<IComboboxOption | null>(null);
  const [gsg, setGsg] = useState<IComboboxOption | null>(null);
  const [rn, setRN] = useState<IComboboxOption | null>(null);
  const [up, setUp] = useState<IComboboxOption | null>(null);
  const [td, setTd] = useState<IComboboxOption | null>(null);
  const [ed, setEd] = useState<IComboboxOption | null>(null);
  const refNroDesviacion = React.createRef<HTMLInputElement>();
  const refFechaDeteccionDesde = React.createRef<HTMLInputElement>();
  const refFechaDeteccionHasta = React.createRef<HTMLInputElement>();
  const totalPageListDesviaciones = useRef<number>(0);
  const [listDesviaciones, setListDesviaciones] = useState<Array<IDesviacion>>(items || []);
  const [busquedaInicial, setBusquedaInicial] = useState(busqueda || false);
  const [isDownloading, setIsDownloading] = useState(false);

  const component = (titulo: string) => {
    return <RenderTitle title={titulo} />;
  };

  const componentValue = (value: any) => {
    return <RenderValue value={value} />;
  };

  const componentOpciones = (value: any) => {
    return (
      <div>
        <i
          className="bi bi-search iconSearch"
          title="Ver Desviación"
          onClick={() => {
            window.location.href = `/agregardesviacion?id=${value.row.original.ID}`;
          }}></i>
      </div>
    );
  };

  usePromiseEffect(async () => {
    let token = await cognitoUserToken();
    setToken(token);

    let resultAllTipoDesviacion = (
      await getAPI(`${URL_SUPPORT}${API_ADMIN_TIPO_DESVIACION}/getall`, { Authorization: `Bearer ${token}` }, cParamsActive)
    ).result;
    let sorted = resultAllTipoDesviacion.data.sort((a: any, b: any) => (a.NOMBRE > b.NOMBRE ? 1 : -1));
    setComboTD(sorted);

    let resultAllVicepresidencias = (await getAPI(`${URL_SUPPORT}${API_VPP}/getall`, { Authorization: `Bearer ${token}` }, cParamsActiveOrderTitle))
      .result;
    setComboVcc(resultAllVicepresidencias.data);

    let resultAllRequisitosNormativos = (
      await getAPI(
        `${URL_SUPPORT}${API_ADMIN_REQ_NORMATIVOS}/getall`,
        { Authorization: `Bearer ${token}` },
        { ...cParamsActiveOrderTitle, ORDENADOPOR: "ITEM", TEXTO_DISTINC: `DISTINCT ON (rn1."ITEM")` }
      )
    ).result;
    setComboRN(resultAllRequisitosNormativos.data);

    let resultAllEstadoDesviacion = (
      await getAPI(`${URL_SUPPORT}${API_ADMIN_ESTADO_DESVIACION}/getall`, { Authorization: `Bearer ${token}` }, cParamsActive)
    ).result;
    setComboED(resultAllEstadoDesviacion.data);
  }, []);

  const fillComboGSG = async (vppId: string) => {
    let paramsActive = {
      ...cParamsActiveOrderTitle,
      VICEPRESIDENCIA: vppId,
    };
    const comboGSG = (await getAPI(`${URL_SUPPORT}${API_ADMIN_GERENCIA}/getall`, { Authorization: `Bearer ${token}` }, paramsActive)).result.data;
    setComboGSG(comboGSG);
  };

  const fillComboUP = async (vppId: string) => {
    let paramsActive = {
      ...cParamsActiveOrderTitle,
      NOMBRE_GERENCIA_SUBGERENCIA: vppId,
    };
    const comboGSG = (await getAPI(`${URL_SUPPORT}${API_ADMIN_UNIDAD}/getall`, { Authorization: `Bearer ${token}` }, paramsActive)).result.data;
    setComboUP(comboGSG);
  };

  const handleValidacionBusqueda = () => {
    let arrErrors = [];
    if (
      !refNroDesviacion.current?.value &&
      !td?.value &&
      !vpp?.value &&
      !rn?.value &&
      !gsg?.value &&
      !ed?.value &&
      !up?.value &&
      !moment(refFechaDeteccionDesde.current?.value).isValid() &&
      !moment(refFechaDeteccionHasta.current?.value).isValid()
    ) {
      arrErrors.push("Debe ingresar un filtro");
    }
    if (moment(refFechaDeteccionDesde.current?.value) > moment(refFechaDeteccionHasta.current?.value)) {
      arrErrors.push("Fecha detección desde no puede ser superior a fecha hasta");
    }
    if (arrErrors.length > 0) {
      MySwal.fire({
        html: (
          <div>
            <h3>Favor seleccione lo siguiente:</h3>
            {arrErrors.map((e) => (
              <p key={e}>{e}</p>
            ))}
          </div>
        ),
        icon: "warning",
        confirmButtonText: "Aceptar",
        showCloseButton: true,
        showCancelButton: false,
      });

      return false;
    }
    return true;
  };

  const getParameters = (pagination?: IPagination) => {
    let defaultPagination = pagination || cParamsActive;
    let paramsBusqueda: ISearchByReporteDesviacion = {
      ...defaultPagination,
      ORIENTACION: "DESC",
      CORRELATIVO: pagination?.CORRELATIVO || refNroDesviacion.current?.value,
      FECHA_DETECCION_DESDE:
        pagination?.FECHA_DETECCION_DESDE || (refFechaDeteccionDesde.current?.value ? new Date(refFechaDeteccionDesde.current?.value) : null),
      FECHA_DETECCION_HASTA: refFechaDeteccionHasta.current?.value ? new Date(refFechaDeteccionHasta.current?.value) : null,
      VICEPRESIDENCIA: vpp?.label,
      GERENCIA_SUBGERENCIA: gsg?.label,
      UNIDAD_PROYECTO: up?.label,
      REQUISITO_NORMATIVO: rn?.label,
      TIPO_DESVIACION: td?.value,
      ID_ESTADO: ed?.value ? parseInt(ed?.value) : null,
    };
    return paramsBusqueda;
  };

  const handleBuscar = async (pagination?: IPagination) => {
    let paramsBusqueda: ISearchByReporteDesviacion = getParameters(pagination);
    if (handleValidacionBusqueda()) {
      let result = await DesviacionService.getReporteDesviacion(token, {
        ...paramsBusqueda,
        PAGINADO: pagination ? pagination?.PAGINADO : ROW_COUNT,
      });
      setListDesviaciones(result.data);
      totalPageListDesviaciones.current = result.pages;
      setBusquedaInicial(true);
    }
  };

  const handleExportExcel = async () => {
    if (handleValidacionBusqueda()) {
      let paramsBusqueda: ISearchByReporteDesviacion = getParameters();
      setIsDownloading(true);
      await DesviacionService.getExcelReporteDesviaciones(token, {
        ...cParamsActiveOrderTitle,
        ...paramsBusqueda,
      });
      setIsDownloading(false);
    }
  };

  const handleLimpiarCampos = () => {
    (refNroDesviacion.current as HTMLInputElement).value = "";
    (refFechaDeteccionDesde.current as HTMLInputElement).value = "";
    (refFechaDeteccionHasta.current as HTMLInputElement).value = "";
    setTd(null);
    setVpp(null);
    setRN(null);
    setGsg(null);
    setEd(null);
    setUp(null);

    setComboGSG([]);
    setComboUP([]);
  };

  const columnHelperDesvGeneradas = createColumnHelper<IDesviacion>();
  let columnsDefDesviaciones = [
    columnHelperDesvGeneradas.accessor((row) => row.CORRELATIVO, {
      id: "CORRELATIVO",
      cell: (info: CellContext<IDesviacion, string>) => componentValue(info.getValue()),
      header: () => component("Correlativo"),
      tipo: ITipo_Campo.text,
    } as any),
    columnHelperDesvGeneradas.accessor((row) => row.ASUNTO, {
      id: "ASUNTO",
      cell: (info: CellContext<IDesviacion, string>) => componentValue(info.getValue()),
      header: () => component("Asunto"),
      tipo: ITipo_Campo.text,
    } as any),
    columnHelperDesvGeneradas.accessor((row) => row.TIPO_DESVIACION, {
      id: "TIPO_DESVIACION_COLUMNA",
      cell: (info: CellContext<IDesviacion, string>) => componentValue(info.getValue()),
      header: () => component("Tipo Desviación"),
      tipo: ITipo_Campo.text,
      sortId: `TD."NOMBRE"`,
    } as any),
    columnHelperDesvGeneradas.accessor((row) => row.REQUISITO_NORMATIVO, {
      id: "REQUISITO_NORMATIVO_COLUMNA",
      cell: (info: CellContext<IDesviacion, string>) => componentValue(info.getValue()),
      header: () => component("Requisito Normativo"),
      tipo: ITipo_Campo.text,
      sortId: `RN."TITULO"`,
    } as any),
    columnHelperDesvGeneradas.accessor((row) => row.DESCRIPCION_INCUMPLIMIENTOS, {
      id: "DESCRIPCION_INCUMPLIMIENTOS",
      cell: (info: CellContext<IDesviacion, string>) => componentValue(info.getValue()),
      header: () => component("Descripción"),
      tipo: ITipo_Campo.text,
    } as any),
    columnHelperDesvGeneradas.accessor((row) => row.FECHA_DETECCION, {
      id: "FECHA_DETECCION_DESDE",
      cell: (info: CellContext<IDesviacion, string>) => componentValue(shortDate(info.getValue())),
      header: () => component("Fecha detección"),
      tipo: ITipo_Campo.date,
    } as any),
    columnHelperDesvGeneradas.accessor((row) => row.VICEPRESIDENCIA, {
      id: "VICEPRESIDENCIA_COLUMNA",
      cell: (info: CellContext<IDesviacion, string>) => componentValue(info.getValue()),
      header: () => component("Vicepresidencia"),
      tipo: ITipo_Campo.text,
    } as any),
    columnHelperDesvGeneradas.accessor((row) => row.GERENCIA_SUBGERENCIA, {
      id: "GERENCIA_SUBGERENCIA_COLUMNA",
      cell: (info: CellContext<IDesviacion, string>) => componentValue(info.getValue()),
      header: () => component("Gerencia Subgerencia"),
      tipo: ITipo_Campo.text,
    } as any),
    columnHelperDesvGeneradas.accessor((row) => row.UNIDAD_PROYECTO, {
      id: "UNIDAD_PROYECTO_COLUMNA",
      cell: (info: CellContext<IDesviacion, string>) => componentValue(info.getValue()),
      header: () => component("Unidad Proyecto"),
      tipo: ITipo_Campo.text,
    } as any),

    columnHelperDesvGeneradas.accessor((row) => row.RESPONSABLE_INVESTIGACION_DISPLAY, {
      id: "RESPONSABLE_ANALISIS_CAUSAL",
      cell: (info: CellContext<IDesviacion, string>) => componentValue(info.getValue()),
      header: () => component("Responsable Análisis Causal"),
      tipo: ITipo_Campo.text,
    } as any),
    columnHelperDesvGeneradas.accessor((row) => row.ESTADO, {
      id: "ESTADO_COLUMNA",
      cell: (info: CellContext<IDesviacion, string>) => componentValue(info.getValue()),
      header: () => component("Estado"),
      tipo: ITipo_Campo.text,
      sortId: `EV."NOMBRE"`,
    } as any),
    columnHelperDesvGeneradas.accessor((row) => row.ID, {
      id: "ACCIONES",
      cell: (info: CellContext<IDesviacion, string>) => componentOpciones(info),
      header: () => component("Opciones"),
      tipo: ITipo_Campo.text,
      disableSorting: true,
    } as any),
  ] as any;

  return (
    <div>
      {isDownloading && <Loading key="loadingDownload" cssContainer="loadingFlotante" />}
      <div className="row">
        <div className="col-12">
          <div className="rounded bg-white p-2 shadow">
            <div className="container-fluid mb-4">
              <h1 className="titPrincipal colorTit">Reporte de Desviaciones</h1>
              <div className="alert alert-warning p-1 mb-2" role="alert">
                <i className="text-info bi bi-info-circle-fill me-2"></i>
                <small>
                  <strong>Nota:</strong> Este reporte permite consultar las Desviaciones realizadas en un período de tiempo.
                </small>
              </div>
              <div className="card bg-light border p-3 pt-2 mt-2">
                <div className="row ajusteInput">
                  <div className="col-sm-12 col-md-6 col-lg-6 pt-0">
                    <label className="text-sm">Número de Desviación</label>
                    <input className="form-control form-control-sm" type="text" placeholder="Indique el número" ref={refNroDesviacion} />
                  </div>
                  <div className="col-sm-12 col-md-6 col-lg-6 pt-0">
                    <label>Tipo de Desviación:</label>
                    <Select
                      options={
                        comboTD.map((vcc) => ({
                          value: vcc.ID,
                          label: vcc.NOMBRE,
                        })) as any
                      }
                      placeholder="Seleccione"
                      value={td || ""}
                      isClearable={true}
                      onChange={(e: any) => {
                        setTd(e || "");
                      }}
                    />
                  </div>
                  <div className="col-sm-12 col-md-6 col-lg-6 pt-0">
                    <label>Vicepresidencia:</label>
                    <Select
                      options={
                        comboVcc.map((vcc) => ({
                          value: vcc.ID,
                          label: vcc.TITULO,
                        })) as any
                      }
                      placeholder="Seleccione"
                      value={vpp || ""}
                      isClearable={true}
                      onChange={(e: any) => {
                        setVpp(e || "");
                        fillComboGSG(e.label || "");
                      }}
                    />
                  </div>
                  <div className="col-sm-12 col-md-6 col-lg-6 pt-0">
                    <label className="text-sm">Requisito Normativo:</label>

                    <Select
                      options={
                        comboRN.map((vcc) => ({
                          value: vcc.ID,
                          label: vcc.TITULO,
                        })) as any
                      }
                      placeholder="Seleccione"
                      value={rn || ""}
                      isClearable={true}
                      onChange={(e: any) => {
                        setRN(e || "");
                      }}
                    />
                  </div>

                  <div className="col-sm-12 col-md-6 col-lg-6 pt-0">
                    <label>Gerencia/Subgerencia:</label>
                    <Select
                      options={
                        comboGSG.map((vcc) => ({
                          value: vcc.ID,
                          label: vcc.TITULO,
                        })) as any
                      }
                      placeholder="Seleccione"
                      value={gsg || ""}
                      isClearable={true}
                      onChange={(e: any) => {
                        setGsg(e || "");
                        fillComboUP(e.label || "");
                      }}
                    />
                  </div>
                  <div className="col-sm-12 col-md-6 col-lg-6 pt-0">
                    <label>Estado:</label>
                    <Select
                      options={
                        comboED.map((vcc) => ({
                          value: vcc.ID,
                          label: vcc.NOMBRE,
                        })) as any
                      }
                      placeholder="Seleccione"
                      value={ed || ""}
                      isClearable={true}
                      onChange={(e: any) => {
                        setEd(e || "");
                      }}
                    />
                  </div>
                  <div className="col-sm-12 col-md-6 col-lg-6 pt-0">
                    <label>Unidad Proyecto:</label>
                    <Select
                      options={
                        comboUP.map((vcc) => ({
                          value: vcc.ID,
                          label: vcc.TITULO,
                        })) as any
                      }
                      placeholder="Seleccione"
                      value={up || ""}
                      isClearable={true}
                      onChange={(e: any) => {
                        setUp(e || "");
                      }}
                    />
                  </div>
                  <div className="col-sm-12 col-md-6 col-lg-6 pt-0"></div>
                  <div className="col-sm-12 col-md-6 col-lg-6 pt-0">
                    <label className="text-sm">Fecha detección (desde - hasta)</label>
                    <div className="d-flex">
                      <input className="form-control form-control-sm w-50 me-2" type="date" placeholder="Desde" ref={refFechaDeteccionDesde} />
                      <input className="form-control form-control-sm w-50" type="date" placeholder="Hasta" ref={refFechaDeteccionHasta} />
                    </div>
                  </div>

                  <div className="col-sm-12 col-md-12 col-lg-12 mt-3">
                    <button
                      type="button"
                      className="btn btn-sm btn-primary me-2"
                      onClick={() => {
                        handleBuscar();
                      }}>
                      {" "}
                      <i className="bi bi-search me-2"></i> Buscar
                    </button>
                    <button
                      type="button"
                      className="btn btn-sm btn-outline-secondary me-2"
                      onClick={() => {
                        handleLimpiarCampos();
                      }}>
                      {" "}
                      <i className="bi bi-trash me-2"></i>Limpiar Campos
                    </button>
                    <button
                      type="button"
                      className="btn btn-sm btn-outline-success me-2"
                      onClick={() => {
                        handleExportExcel();
                      }}>
                      <i className="bi bi-file-earmark-excel"></i> Exportar Excel
                    </button>
                  </div>
                </div>
              </div>

              <div className="" id="collapseGeneradas">
                <div className="card card-body border-0 p-0 mt-2">
                  <div className="row">
                    <div className="col-12">
                      <div className="container-fluid mb-4">
                        <h1 className="titPrincipal colorTit mt-2"></h1>

                        <div className="row">
                          <div className="col-12">
                            {busquedaInicial && (
                              <AdminListaPagination
                                defaultSortBy="ID"
                                sortDirection="DESC"
                                totalPages={totalPageListDesviaciones}
                                resultPerPage={pageSize}
                                callbackUpdatePageSize={(pageSize: number, filters: Object) => {
                                  setPageSize(pageSize);
                                  let pagination = filters as IPagination;
                                  pagination.PAGINA = 1;
                                  pagination.PAGINADO = pageSize;
                                  handleBuscar(pagination);
                                }}
                                callback={(pagination) => {
                                  console.log(pagination);
                                  if (pagination.CORRELATIVO === "") pagination.CORRELATIVO = undefined;
                                  handleBuscar(pagination);
                                }}
                                data={listDesviaciones}
                                reload={() => {
                                  handleBuscar();
                                }}
                                columnsDef={columnsDefDesviaciones}
                                hideAdd={true}
                                hideExport={true}
                              />
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
